import React, { useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import WHGTd from "./WHGTd";
import WorkIcon from "@mui/icons-material/Work";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import PersonIcon from "@mui/icons-material/Person";

function WorkingHG({ timeData, weekArray, dentists, setdoctorId, doctorId }: any) {
  const [dentalActiveDays, setdentalActiveDays] = useState([]);
  const [dentistActiveDays, setdentistActiveDays] = useState([]);

  useEffect(() => {
    if (doctorId) {
      baseUrl
        .get("/managetime/getWorkingHoursGeneral", {
          headers: { doctorId: doctorId },
        })
        .then((response) => {
          setdentalActiveDays(response.data.openHourGeneral);
          setdentistActiveDays(response.data.workingHourGeneral);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [doctorId]);

  const handleGeneralWorkingHours = (e: any) => {
    e.doctorId = doctorId;
    baseUrl
      .post("/managetime/workingHoursGeneral", e)
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const [edit, setedit] = useState(false);

  const onEdit = () => {
    if (edit) {
      window.location.reload();
    } else {
      setedit(!edit);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-100 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
            <WorkIcon className="text-white" sx={{ fontSize: 20 }} />
          </div>
          <h3 className="text-lg font-bold text-slate-800">Working Hours (General)</h3>
        </div>
        <div className="flex items-center gap-3">
          <div className="relative">
            <PersonIcon
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              sx={{ fontSize: 20 }}
            />
            <select
              value={doctorId}
              onChange={(e) => setdoctorId(e.target.value)}
              className="pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all appearance-none min-w-[200px]"
            >
              <option value="">Select doctor</option>
              {dentists?.map((item: any, i: number) => (
                <option key={i} value={item?._id}>
                  Dr. {item?.title + " " + item?.lastName}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={() => onEdit()}
            className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all ${
              edit
                ? "bg-amber-500 text-white hover:bg-amber-600"
                : "bg-slate-100 text-slate-600 hover:bg-slate-200"
            }`}
          >
            {edit ? <SaveIcon sx={{ fontSize: 18 }} /> : <EditIcon sx={{ fontSize: 18 }} />}
            {edit ? "Save" : "Edit"}
          </button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50/80">
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider min-w-[80px]">
                Time
              </th>
              {weekArray?.map((item: any, i: number) => (
                <th
                  key={i}
                  className="px-2 py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider"
                >
                  {window.innerWidth > 500 ? item?.week : item?.abbreviation}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {timeData?.map((time: any, index: number) => (
              <tr key={index} className="hover:bg-slate-50/50">
                <td className="px-4 py-2 text-sm font-medium text-slate-600">
                  {time?.formattedTime}
                </td>
                {weekArray?.map((day: any, idx: number) => (
                  <WHGTd
                    onClick={handleGeneralWorkingHours}
                    key={idx}
                    edit={edit}
                    dataHeader={{
                      day: day?.week,
                      startTime: time?.startTime,
                      endTime: time?.endTime,
                      interval: time?.interval,
                    }}
                    activeTime={
                      dentalActiveDays?.filter(
                        (item: any) =>
                          item?.day === day?.week &&
                          item?.startTime === time?.startTime &&
                          item?.endTime === time?.endTime
                      ).length === 1
                    }
                    deactiveTime={
                      dentistActiveDays?.filter(
                        (item: any) =>
                          item?.day === day?.week &&
                          item?.startTime === time?.startTime &&
                          item?.endTime === time?.endTime
                      ).length === 1
                    }
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default WorkingHG;
